import { AnimatePresence } from "framer-motion";
import { useManagePaymentMethods } from "./ManagePaymentMethodsContext";
import Placeholder from "UserProfile/Tabs/Common/Placeholder";

export default function NoPaymentMethodsPlaceholder() {
  const { paymentMethods } = useManagePaymentMethods().state;

  return (
    <AnimatePresence>
      {paymentMethods && paymentMethods.length === 0 && (
        <Placeholder
          title="You don't have any payment methods on file."
          icon="far fa-credit-card"
          text="You can securely add payment methods here and we'll remember them for the next time you want to give a gift to your church."
        />
      )}
    </AnimatePresence>
  );
}
